import styled from 'styled-components';

export const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr); 
  grid-template-rows: repeat(8, 1fr);
  width: 100vw;
  height: 100vh;
  background: #fff;
  gap: 12px;
  padding: 12px;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
`;

// export const ReorderWrapper = styled.div`
//   order: 0;

//   @media (max-width: 768px) {
//     order: ${props => props.mobileOrder || 0};
//   }
// `;

export const Block = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  color: #000;
  background: #f0f0f0;
  letter-spacing: 0.1em;

  &:hover {
    background:rgb(255, 203, 203);
  }
  @media (max-width: 768px) {
    height: 8rem;      /* twice as tall */
  }
`;

export const Home = styled.div`
  grid-column: 1 / 3;
  grid-row: 1 / 6;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(255, 203, 203);
  // background-color: #f0f0f0;
   &:hover {
    background:rgb(255, 203, 203);
  }
  overflow: visible;

  @media (max-width: 768px) {
    height: 12rem;      /* twice as tall */
  }
`;


export const LogoImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  padding: 25%;
  object-fit: contain;

  @media (max-width: 768px) {
    padding: 10%;
  }
`;



export const TooltipOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(255, 203, 203, 0.95);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.4s ease;
  padding: 1rem;
  text-align: center;

  p {
    margin: 0;
    font-size: 0.9rem;
    line-height: 1.3;
  }

  ${({ show }) => show && `
    opacity: 1;
    `}
`;

export const LogoContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  &:hover ${TooltipOverlay}  {
    opacity: 1;  
  }
`;

export const BottomLeftRow = styled.div`
  grid-column: 1 / 3;
  grid-row: 6 / 9;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    height: 12rem;
  }
`;

export const BottomRightRow = styled.div`
  grid-column: 3 / 5;
  grid-row: 7 / 9;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;

   @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    height: 12rem;
  }
`;

